import { Box, Tab } from '@mui/material';
import { DateRangePicker } from '@mui/x-date-pickers-pro';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { SolaForceTabs } from '~/components/SolaForceTabs';
import { EmployeeChangeActivityLog } from '~/scenes/PeopleModule/components/EmployeeActions/EmployeeActivityLogDialog/components/EmployeeActivityLog/EmployeeChangeActivityLog';
import { EmployeeViewActivityLog } from '~/scenes/PeopleModule/components/EmployeeActions/EmployeeActivityLogDialog/components/EmployeeActivityLog/EmployeeViewActivityLog';
import {
  UserActivityLogTab,
  useEmployeeActivityLog,
} from '~/scenes/PeopleModule/components/EmployeeActions/EmployeeActivityLogDialog/components/EmployeeActivityLog/useEmployeeActivityLog';
import { useSxStyles } from '~/scenes/PeopleModule/components/EmployeeActions/EmployeeActivityLogDialog/components/EmployeeActivityLog/useStyles';

type PropsType = {
  employeeId: number;
};

const EmployeeActivityLogTabs = (props: {
  employeeId: number;
  startDate: Date;
  endDate: Date;
  tab: UserActivityLogTab;
}) => {
  const { tab, ...logProps } = props;

  switch (tab) {
    case UserActivityLogTab.Views:
      return <EmployeeViewActivityLog {...logProps} />;
    case UserActivityLogTab.Changes:
      return <EmployeeChangeActivityLog {...logProps} />;
    default:
      return <></>;
  }
};

export const EmployeeActivityLog = (props: PropsType) => {
  const { employeeId } = props;

  const { t } = useTranslation();

  const sxStyles = useSxStyles();

  const { selectedDateRange, dateRangePickerProps, tabs } =
    useEmployeeActivityLog(employeeId);

  return (
    <Box sx={sxStyles.root}>
      <Box sx={sxStyles.toolbar}>
        <DateRangePicker
          {...dateRangePickerProps}
          slotProps={{
            fieldRoot: {
              sx: sxStyles.datePicker,
            },
            textField: ({ position }) => ({
              label: position === 'start' ? t('startDate') : t('endDate'),
              size: 'small',
              sx: sxStyles.textField,
            }),
          }}
        />
        <Box sx={sxStyles.tabs}>
          <SolaForceTabs value={tabs.value} onChange={tabs.onChange}>
            {tabs.options.map(({ value, label }, index) => {
              return (
                <Tab
                  key={`tab-${index}`}
                  label={label}
                  value={value}
                  data-cy={value}
                />
              );
            })}
          </SolaForceTabs>
        </Box>
      </Box>
      <Box sx={sxStyles.contentSlot}>
        <Box sx={sxStyles.content}>
          <EmployeeActivityLogTabs
            employeeId={employeeId}
            {...selectedDateRange}
            tab={tabs.value}
          />
        </Box>
      </Box>
    </Box>
  );
};
